class ProductImageZoom extends HTMLElement {
    constructor() {
        super();

        if (!document.getElementById('zoom')) {
            this.zoom = document.createElement('div');
            this.zoom.id = 'zoom';
            this.zoom.innerHTML = `
                <img />
                <span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
                <span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
                <div class="zoom__overlay"></div>
            `;
            document.body.append(this.zoom);
            this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
        } else {
            this.zoom = document.getElementById('zoom');
        }

        this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

        this.addEventListener('click', (e) => {
            this.zoom.classList.add('opened');
            this.image = this.zoom.querySelector('img');
            this.image.src = this.getAttribute('data-image');
            if (this.image.naturalWidth > 0) {
                this._productZoomMount();
            } else {
                this.image.addEventListener('load', this._productZoomMount.bind(this));
            }
        });
    }

    onResizeHandler() {
        const rfMobile = 0.8; // 80% of the screen width for mobile
        const rfDesktop = 0.4; // 60% of the screen width for desktop

        if (window.innerWidth >= 900) { // Desktop view
            this.image.style.width = (window.innerWidth * rfDesktop) + 'px';
            this.image.style.height = 'auto';
        } else { // Mobile view
            this.image.style.width = (window.innerWidth * rfMobile) + 'px';
            this.image.style.height = 'auto';
        }

        const x = (window.innerWidth - this.image.offsetWidth) / 2;
        const y = (window.innerHeight - this.image.offsetHeight) / 2;
        this.image.style.left = Math.max(0, x) + 'px';
        this.image.style.top = Math.max(0, y) + 'px';
    }

    _productZoomMount() {
        this.image.style.left = 0;
        this.image.style.top = 0;

        // Hide scrollbar
        document.body.style.overflow = 'hidden';

        window.addEventListener('resize', this.onResizeHandlerBinded, { passive: true });
        this.onResizeHandler();

        setTimeout(() => {
            if (document.body.classList.contains('touch') || document.body.classList.contains('touchevents')) {
                this.zoom.scrollTop = (window.innerHeight - this.image.offsetHeight) / -2;
                this.zoom.scrollLeft = (window.innerWidth - this.image.offsetWidth) / -2;
            }
            this.zoom.classList.add('loaded');
        }, 50);
    }

    _productZoomUnmount() {
        this.zoom.classList.remove('opened');

        // Show scrollbar
        document.body.style.overflow = '';

        setTimeout(() => {
            window.removeEventListener('resize', this.onResizeHandlerBinded);
            const image = document.querySelector('#zoom img');
            image.src = '';
            image.className = '';
            image.style = '';
            this.zoom.classList.remove('loaded');
        }, 300);
    }
}

if (typeof customElements.get('product-image-zoom') === 'undefined') {
    customElements.define('product-image-zoom', ProductImageZoom);
}
